import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import Screens from '../../constants/routing/Screens';
import { useIsMobile } from '../../context/IsMobileContext';
import { Section } from '../common/SharedComponents';
import CommerceFeatureTable from './CommerceFeatureTable';
import CommerceFeatureTableModal from './CommerceFeatureTableModal';
const StyledLink = styled(UILink).withConfig({
  displayName: "CommerceFeatureTableContainer__StyledLink",
  componentId: "sc-1tc55bg-0"
})(["&.features-link{", "}"], breakpoint.phone(_t || (_t = _`
      font-weight: 600;
    `)));

function CommerceFeatureTableContainer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useIsMobile();

  const onClickSeeAllFeaturesLink = () => {
    setIsModalOpen(true);
    getUsageTracker().track('clickToViewModal', {
      name: 'compare-feature-modal',
      productLine: COMMERCE
    });
  };

  if (isMobile) return /*#__PURE__*/_jsxs(Section, {
    className: "justify-center",
    children: [isModalOpen && /*#__PURE__*/_jsx(CommerceFeatureTableModal, {
      onCloseClick: () => setIsModalOpen(false)
    }), /*#__PURE__*/_jsx(StyledLink, {
      onClick: onClickSeeAllFeaturesLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.highlightedMerchCards.seeAllFeatures"
      })
    })]
  });
  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsx(CommerceFeatureTable, {
      screen: Screens.COMMERCE
    })
  });
}

export default CommerceFeatureTableContainer;